module.exports = __webpack_public_path__ + "static/media/astro_education_executive_misc.0e7dd120.png";